<template>
    <base-page :title="$t('l.terminal_manage')" icon="ios-ionitron">
            <Row type="flex"  slot="extra" justify="end">
                <Col>
                    <template v-if="$ifauth('fun_device_terminal_code')">
                        <Button ghost type="primary" @click="addBand">{{$t('l.yd_bound')}}</Button>
                    </template>
                </Col>
                <Col class="margin-left-5">
                    <Button @click="loadData(table.page.current,table.page.keyword)">{{$t('l.fresh')}}</Button>
                </Col>
                <Col class="margin-left-5 margin-right-5">
                    <Input v-model="table.page.keyword" search suffix="ios-search" :placeholder="$t('l.remark67')"
                           @on-search="loadData(1,$event)" @on-change="onSearch"/>
                </Col>
            </Row>
        <template>
            <Table stripe border :columns="getColumns" :data="table.data" :loading="table.loading">
            </Table>
            <Row type="flex" justify="center">
                <Col>
                    <Page size="small" :current="table.page.current"
                          :page-size="table.page.size"
                          :total="table.page.total"
                          :page-size-opts="[10,15,20,25,30]"
                          show-sizer
                          @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
                          @on-change="loadData(table.page.current,table.page.keyword)"
                          show-elevator>
                    </Page>
                </Col>
            </Row>
            <canvas id="canvas"></canvas>
        </template>
        <!-- 终端信息 -->
        <lg-modal :title="modal.title" :show="modal.show" :loading="modal.loading" @on-submit="onSubmit"
                  @on-cancel="modal.loading=false; modal.show = false;">
            <Form :model="modal.terminal" :label-width="120" label-position="left">
                <FormItem :label="$t('l.terminal_identity')">
                    <Input :value="modal.terminal.identity==0?$t('l.terminal_smart'):modal.terminal.identity==1?$t('l.dty')+'app':modal.terminal.identity==2?$t('l.terminal_face'):modal.terminal.identity==3?$t('l.terminal_new_wcr'):$t('l.terminal_old_wcr')"
                           :disabled="true"/>
                </FormItem>
                <FormItem :label="$t('l.terminal_account')">
                    <Input v-model="modal.terminal.device_name" :disabled="true"/>
                </FormItem>
                <FormItem :label="$t('l.terminal_pwd')">
                    <Input v-model="modal.terminal.device_secret" :disabled="true"/>
                </FormItem>
                <FormItem v-if="modal.terminal.yd_unique_code" :label="$t('l.yd_unique_code')">
                    <Input v-model="modal.terminal.yd_unique_code" :disabled="true"/>
                </FormItem>
            </Form>
        </lg-modal>
        <!-- 怡达设备 唯一设备工号录入 -->
        <lg-modal :show="ydModal.show"
                  :title="$t('l.yd_id_add')"
                  @oncancel="ydModal.show=false"
                  @on-submit="onEntry('ydModal')"
                  :loading="ydModal.loading"
                  @on-cancel="ydModal.show = false;"
                  :confirm-text="'l.input'">
            <Form label-position="left" :rules="ydModal.rules" ref="ydModal" :model="ydModal" :label-width="150" >
                <FormItem :label="$t('l.yd_unique_code')" prop="ydDevice.yd_unique_code">
                    <Input :placeholder="$t('l.yd_unique_code')" v-model="ydModal.ydDevice.yd_unique_code"/>
                </FormItem>
                <p class="explain margin-bottom-10">{{$t("l.warn_note")}}：{{$t("l.explain15")}}</p>
                <FormItem :label="$t('l.terminal_id')" prop="ydDevice.device_name">
                    <Input @on-change="changeYdDeviceName" :placeholder="$t('l.remark102')"
                           v-model="ydModal.ydDevice.device_name"/>
                </FormItem>
            </Form>
        </lg-modal>
    </base-page>
</template>

<script>
    import ResView from "../my-components/res-view";
    import BasePage from "../my-components/base-page";
    import util from '@/libs/util';
    import LgModal from "../my-components/lg-modal";
    import QRCode from 'qrcode';
    import Print from 'print-js';

    export default {
        name: 'page-terminal',
        components: {LgModal, BasePage, ResView},
        data() {
            return {
                search: '',
                spliter: {
                    l_r: 0.2,
                    t_b: 0.5
                },
                regionTree: [],
                currentTerminal: {
                    deviceName: '',
                    deviceSecret: '',
                    netType: '',
                    createTime: '',
                    activateTime: '',
                    lastOnlineTime: '',
                    custormer: '',
                    state: ''
                },
                netTypeList: [
                    {
                        label: 'l.no_connect',
                        value: -1
                    },
                    {
                        label: 'l.wired_network',
                        value: 0
                    },
                    {
                        label: 'WIFI',
                        value: 1
                    },
                    {
                        label: '2G',
                        value: 2
                    },
                    {
                        label: '3G',
                        value: 3
                    },
                    {
                        label: '4G',
                        value: 4
                    },
                    {
                        label: '5G',
                        value: 5
                    }
                ],
                identityList: [
                    {
                        label: 'l.terminal_smart',
                        value: 0
                    },
                    {
                        label: 'l.terminal_app',
                        value: 1
                    },
                    {
                        label: 'l.terminal_face',
                        value: 2
                    },
                    {
                        label: 'l.terminal_new_wcr',
                        value: 3
                    },
                    {
                        label: 'l.terminal_old_wcr',
                        value: 4
                    },
                ],
                table: {
                    loading: false,
                    selected: [],
                    columns: [],
                    data: [],
                    page: {
                        current: 1,
                        size: 10,
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword: ''
                    },
                    otherField: -1
                },
                modal: {
                    show: false,
                    title: this.$t('l.terminal'),
                    loading: false,
                    currentIndex: -1,
                    terminal: {},
                },
                // 怡达 专用设备terminal_id 与 编号绑定关系录入
                ydModal: {
                    show: false,
                    loading: false,
                    ydDevice: {
                        device_name: '',
                        yd_unique_code: ""
                    },
                    rules: {
                        'ydDevice.yd_unique_code': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
                        'ydDevice.device_name': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}]
                    },
                },
                formRules: {
                    username: [
                        {required: true, message: this.$t('l.remark38'), trigger: 'blur'}
                    ],
                    realname: [
                        {required: true, message: this.$t('l.remark39'), trigger: 'blur'}
                    ],
                    job_num: [
                        {required: true, message: this.$t('l.remark40'), trigger: 'blur'}
                    ],
                    j_depart_ids: [
                        {required: true, type: 'array', min: 1, message: this.$t('l.remark103'), trigger: 'on-select'}
                    ]
                },
                current: {
                    region: {}
                },
                checkAll: false,
                indeterminate: true
            };
        },
        methods: {
            filterLoadData(val, row) {
                if (val.length) {
                    this.loadData(1, this.table.page.keyword)
                } else {
                    this.otherField.splice(0, 1)
                    this.loadData(this.table.page.current, this.table.page.keyword)
                }
            },
            changeYdDeviceName() {
                let data = this.ydModal.ydDevice.device_name;
                if (data && data.indexOf("W") == -1) {
                    this.ydModal.ydDevice.device_name = "W_" + data;
                } else {
                    this.ydModal.ydDevice.device_name = data;
                }
            },
            onSearch() {
                if (!this.table.page.keyword) this.loadData(1);
            },
            addBand() {
                this.ydModal.show = true
                this.$refs.ydModal.resetFields();
                this.ydModal.loading = false;
            },
            loadData(page) {
                this.table.loading = true;
                util.ajax.post('/terminal/getlist', {
                        page: page || 1,
                        size: this.table.page.size,
                        orderKey: this.table.page.sortKey,
                        orderMethod: this.table.page.sortMethod,
                        keyword: this.table.page.keyword,
                        otherField:this.table.otherField
                }).then((res) => {
                    this.table.loading = false;
                    this.table.page.current = res.current;
                    this.table.page.total = res.total;
                    this.table.data = util.deepCopy(res.list);
                    this.table.selected = [];
                });
            },
            preEdit(terminal, index) {
                this.modal.currentIndex = index;
                this.modal.terminal = util.deepCopy(terminal);
                this.modal.title = this.$t('l.terminal_info');
                this.modal.show = true;
            },
            renderRegionTree(h, {root, node, data}) {
                return h('span', {
                    class: {
                        'tree-line': true,
                        'active': this.current.region === data
                    },
                    on: {
                        click: () => {
                            let selected = [data.id];
                            let j_region = {
                                province: {
                                    id: data.id,
                                    name: data.name
                                }
                            };
                            if (node.parent) {
                                let pNode = root[node.parent];
                                selected.unshift(pNode.node.id);

                                j_region.city = j_region.province;
                                j_region.province = {
                                    id: pNode.node.id,
                                    name: pNode.node.name
                                }

                                if (pNode.parent) {
                                    let gNode = root[pNode.parent];
                                    selected.unshift(gNode.node.id);
                                    j_region.area = j_region.city;
                                    j_region.city = j_region.province;
                                    j_region.province = {
                                        id: gNode.node.id,
                                        name: gNode.node.name
                                    }
                                }
                            }
                            this.modal.j_region_temp = j_region;
                            this.modal.selectedRegion = selected;
                            this.current.region = data;
                        }
                    }
                }, data.name)
            },
            onSelectedRegionChange(value, selectedData) {
                if (selectedData[0]) {
                    this.modal.community.j_region.province = {
                        id: selectedData[0].id,
                        name: selectedData[0].name
                    }
                }
                if (selectedData[1]) {
                    this.modal.community.j_region.city = {
                        id: selectedData[1].id,
                        name: selectedData[1].name
                    }
                }
                if (selectedData[2]) {
                    this.modal.community.j_region.area = {
                        id: selectedData[2].id,
                        name: selectedData[2].name
                    }
                }
            },
            setTreeMap(tree, map) {
                tree.forEach(node => {
                    map[node.id.toString()] = node;
                    if (node.children) this.setTreeMap(node.children, map);
                })
            },
            show(index) {
                this.$Modal.info({
                    title: 'User Info',
                    content: `Name：${this.table.data[index].name}<br>Age：${this.table.data[index].age}<br>Address：${this.table.data[index].address}`
                })
            },
            remove(index) {
                this.table.data.splice(index, 1);
            },
            preAdd() {
                this.modal.community = {
                    name: '',
                    address: '',
                    j_buildings: [],
                    j_region: this.modal.j_region_temp
                }
                this.modal.title = this.$t('l.create_community');
                this.modal.show = true;
            },
            setSelected(departs) {
                if (!this.modal.user.j_depart_ids.length) return;
                departs.forEach(depart => {
                    if (this.modal.user.j_depart_ids.includes(depart.id)) {
                        depart.checked = true;
                    }
                    depart.expand = true;
                    if (depart.children) this.setSelected(depart.children);
                })
            },
            onSubmit() {
            },
            onEntry(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.ydModal.loading = true
                        util.ajax.post('/terminal/update', this.ydModal.ydDevice).then(res => {
                            this.ydModal.loading = false
                            if (!res.code) {
                                this.loadData(this.table.page.current, "");
                                this.$Message.success(this.$t('l.success'));
                            }
                        })
                    } else {
                        this.$Message.warning(this.$t('l.remark24'))
                    }
                })
            },
            doCopy(text) {
                let that = this;
                this.$copyText(text).then(function (e) {
                    that.$Notice.open({
                        title: that.$t('l.success'),
                        desc: text + '<br>' + that.$t('l.copy_info')
                    });
                }, function (e) {
                    that.$Message.error(this.$t('l.fail'));
                });
            },
            // handleCheckAll(){
            //     if (this.indeterminate) {
            //         this.checkAll = false;
            //     } else {
            //         this.checkAll = !this.checkAll;
            //     }
            //     this.indeterminate = false;
            //     if (this.checkAll) {
            //         this.modal.j_extra_capacity.list = ['face', 'qrcode', 'monitor','radio','help','ad'];
            //     } else {
            //         this.modal.j_extra_capacity.list = [];
            //     }
            // },
            checkAllGroupChange(data) {
                if (data.length === 6) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            }
        },
        created() {
            util.ajax.get('/region/list').then(res => {
                this.regionTree = res.data;
            })
            this.loadData();
        },
        computed: {
            getColumns() {
                let that = this;
                return [
                    {
                        title: 'ID',
                        align: 'center',
                        width: 80,
                        key: 'id'
                    },
                    {
                        title: this.$t('l.terminal_identity'),
                        align: 'center',
                        width: 280,
                        key: 'identity',
                        render: (h, params) => {
                            for (let type of this.identityList) {
                                if (type.value === params.row.identity) {
                                    return h('span', this.$t(type.label))
                                }
                            }
                        },
                        filters: [
                            {
                                label: this.$t('l.terminal_smart'),
                                value: 0
                            },
                            {
                                label: this.$t('l.terminal_app'),
                                value: 1
                            },
                            {
                                label: this.$t('l.terminal_face'),
                                value: 2
                            },
                            {
                                label: this.$t('l.terminal_new_wcr'),
                                value: 3
                            },
                            {
                                label: this.$t('l.terminal_old_wcr'),
                                value: 4
                            },
                        ],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            that.table.otherField = value[0];
                            that.filterLoadData(value, row);
                        }
                    },
                    {
                        title: this.$t('l.terminal_account'),
                        align: 'center',
                        key: 'device_name',
                        width: 200,
                        render: (h, params) => {
                            return h('ButtonGroup', [
                                h('Button', {
                                    on: {
                                            click: (el) => {
                                            this.doCopy(params.row.device_name);
                                        }
                                    }
                                }, params.row.device_name)
                            ]);
                        }
                    },
                    {
                        title: this.$t('l.terminal_pwd'),
                        align: 'center',
                        key: 'device_name',
                        width: 220,
                        render: (h, params) => {
                            return h('ButtonGroup', [
                                h('Button', {
                                    on: {
                                        click: () => {
                                            this.doCopy(params.row.device_secret);
                                        }
                                    }
                                }, this.$t('l.click_copy_pwd'))
                            ]);
                        }
                    },
                    {
                        title: this.$t('l.network'),
                        align: 'center',
                        width: 200,
                        key: 'net_type',
                        render: (h, params) => {
                            for (let type of this.netTypeList) {
                                if (params.row.net_type == type.value) {
                                    return h('span', this.$t(type.label));
                                }
                            }
                        }
                    },
                    {
                        title: this.$t('l.create_time'),
                        align: 'center',
                        width: 180,
                        key: 'create_time',
                        render: (h, params) => {
                            return h('div', params.row.create_time);
                        }
                    },
                    {
                        title: this.$t('l.update_time'),
                        align: 'center',
                        width: 180,
                        key: 'update_time',
                        render: (h, params) => {
                            return h('div', params.row.update_time);
                        }
                    },
                    {
                        title: this.$t('l.operation'),
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('ButtonGroup', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: "8px"
                                    },
                                    on: {
                                        click: () => {
                                            this.preEdit(params.row, params.index)
                                        }
                                    }
                                }, this.$t('l.check')),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.info({
                                                title: 'MQTT：' + params.row.device_name,
                                                width: 260,
                                                okText: this.$t('l.close'),
                                                render: (h1) => {
                                                    let canvas = h1('canvas');
                                                    let printEle = h1('div', {attrs: {id: 'printCanvas'}}, [
                                                        canvas,
                                                        h1('h4', {
                                                            style: {
                                                                textAlign: 'center'
                                                            }
                                                        }, params.row.device_name)
                                                    ])
                                                    setTimeout(() => {
                                                        QRCode.toCanvas(canvas.elm, JSON.stringify({
                                                            name: params.row.device_name,
                                                            secret: params.row.device_secret
                                                        }), {
                                                            width: 220,
                                                            height: 220
                                                        }, (e) => {
                                                        })
                                                    }, 300)
                                                    let aaa = h1('div', [
                                                        printEle, h1('Button', {
                                                            on: {
                                                                click: () => {
                                                                    Print({
                                                                        printable: 'printCanvas',
                                                                        type: 'html',
                                                                        scanStyles: true
                                                                    })
                                                                }
                                                            }
                                                        }, this.$t('l.print'))
                                                    ]);
                                                    return aaa;
                                                }
                                            })
                                        }
                                    }
                                }, this.$t('l.qr_code')),
                            ]);
                        }
                    }
                ]
            }
        }
    };

</script>

<style lang="less" scoped>

    .btn-context-menu {
        & > span {
            cursor: pointer;
            margin: 0 3px;
            & > i {
                transition: transform 0.3s;
            }
            &:hover > i {
                transform: rotateY(180deg);
            }
        }

    }
</style>
